module.exports = __webpack_public_path__ + "img/Swirls1264x898.9209ad59.webp";